import { Component, h } from '@stencil/core';

@Component({
  tag: 'signet-h3',
  styleUrl: 'signet-h3.scss',
  shadow: true,
})
export class SignetH3 {
  render() {
    return <h3><slot /></h3>;
  }
}
